










import Vue from 'vue'
import BaseText from '../atoms/BaseText.vue'

export default Vue.extend({
  components: {
    BaseText
  }
})
